import api from "../../api/api";

const getAvailableTimeSlots = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("/appointment/available-timeslots",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const doSlotBooking = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("/appointment/do-slot-booking",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}



const appointmentServices = {
    getAvailableTimeSlots,
    doSlotBooking,
    
}
export default appointmentServices;